import $ from "jquery";

function noScriptValidator(
    $el,      /* jQuery element to validate */
    required, /* is the element required according to the `[required]` attribute */
    parent    /* parent of the jQuery element `$el` */
  )
{
    //string should not contain any script tags
    var scr = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
    return !(scr.test($el.val()));
};

Foundation.Abide.defaults.patterns['phone'] = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
Foundation.Abide.defaults.patterns['postal_code'] = /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/;
Foundation.Abide.defaults.validators['noscript'] = noScriptValidator;

class RequestAppointmentForm {

    /**
     * Constructor
     * 
     * @param {jquery object} f
     */
    constructor(f)
    {
        this.form = f;
    }

    init()
    {
        console.log("init request appt form");

        //Refresh the communities dropdown when a market area is selected
        this.form.find("#region-dropdown").change(function () {
            let dd = $(this);
            let selectedMarketAreaNodeGUID = dd.val();

            //Retrieve the communities of the given market area
            $.ajax("/request-appointment/communitiesofmarketarea/",
                {
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    type: 'POST',
                    data: JSON.stringify({ "marketArea": selectedMarketAreaNodeGUID }),
                    success: function (response) {
                        let communities = JSON.parse(response);
                        let communitydd = $('#community-dropdown');

                        communitydd.val('');

                        //Empty out the dropdown list and append the Select Community option.
                        communitydd.empty().append($('<option></option>').val('').html('Select Community'));

                        if (communities.length > 0) {
                            communitydd.removeAttr("disabled");
                            $.each(communities, function () {
                                //Append the community options
                                //SFCommunityName can be empty, so default to DocumentName
                                let optionVal = this['SFCommunityName'] ? this['SFCommunityName'] : this['DocumentName'];
                                communitydd.append($("<option></option>").val(optionVal).html(this['DocumentName']));
                            });
                        }
                        else {
                            communitydd.attr("disabled", "disabled");
                        }
                        window.initCustomDropdowns();
                    }
                });
        });
    }
}

$(document).ready(function () {
    let requestAppointmentUI = $('#request-appointment-form');
    if (requestAppointmentUI.length > 0) {
        let reqAppt = new RequestAppointmentForm(requestAppointmentUI);
        reqAppt.init();
    }
});
